import { Component, OnInit, Inject } from "@angular/core";
import { FormArray, FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import * as FileSaver from "file-saver";

import { DocumentService } from "../shared/document.service";
import { SnackBarService } from "../../core/snack-bar.service";

import { QuoteDocGenData } from "../shared/quote-doc-gen-data.model";
import { RepaymentOption } from "../shared/repayment-option.model";

@Component({
    template: require('./download-quote-dialog.component.html'),
    styles: [require('./download-quote-dialog.component.css')]
})
export class DownloadQuoteDialogComponent implements OnInit {
    downloadQuoteForm: FormGroup;
    enquiryID: number;
    repaymentOptions: RepaymentOption[];
    showSpinner: boolean;

    constructor(
        private documentService: DocumentService,
        private fb: FormBuilder,
        private snackBarService: SnackBarService,
        @Inject(MAT_DIALOG_DATA) public data: any,
        public dialogRef: MatDialogRef<DownloadQuoteDialogComponent>) {

        this.downloadQuoteForm = this.fb.group({
            showAssetCost: [true, Validators.required],
            repaymentOptionCheckboxes: this.fb.array([]),
        });
    }

    ngOnInit() {
        this.enquiryID = this.data.enquiryID as number;
        this.repaymentOptions = this.data.repaymentOptions as RepaymentOption[];
        const selectedRepaymentIndex = this.data.selectedRepaymentIndex as number;

        this.repaymentOptions.forEach((opt, index) => {
            this.repaymentCheckboxesFA.push(new FormControl(index === selectedRepaymentIndex));
        });
    }

    get repaymentCheckboxesFA(): FormArray { return this.downloadQuoteForm.get("repaymentOptionCheckboxes") as FormArray; }

    displayPaymentFrequency(index: number): boolean {
        return (index == 0)
            || (this.repaymentOptions[index - 1].paymentFrequencyID != this.repaymentOptions[index].paymentFrequencyID)
    }

    downloadQuote(): void {
        const checkboxValues: boolean[] = this.repaymentCheckboxesFA.value;
        if (!checkboxValues.some(checked => checked === true)) {
            this.snackBarService.openSnackBar("Please select at least one repayment option.");
            return;
        }

        this.showSpinner = true;
        const showAssetCost = this.downloadQuoteForm.get('showAssetCost').value as boolean;
        const quoteDocGenData = this.documentService.prepareQuoteDocGenData(showAssetCost, checkboxValues, this.repaymentOptions);
        
        this.documentService.downloadQuotePdf(this.enquiryID, quoteDocGenData)
            .subscribe(
            res => {
                this.showSpinner = false;
                var fileName = res.headers.get("Content-Disposition").match(/"(.*?)"/g).toString(); // get the string between the quotes, but includes the quotes
                fileName = fileName.replace(/["]+/g, ''); // remove the quotes

                FileSaver.saveAs(res.body, fileName);
            },
            err => {
                this.showSpinner = false;
                this.snackBarService.openSnackBar(err as string)
            },
            () => {
                this.dialogRef.close();
            });
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./src/app/enquiry/download-quote-dialog/download-quote-dialog.component.ts